import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SolutionCard from '../components/SolutionCard';
import { solutions } from '../data/solutionsData';

const SolutionsPage: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="d-flex flex-column min-vh-100">
            <Header />

            <main className="flex-grow-1">
                {/* Solutions Section */}
                <section className="solutions py-5" style={{
                    marginTop: '60px',
                    position: 'relative'
                }}>
                    <style>
                        {`.solutions::before { display: none; }`}
                    </style>
                    <div className="container">
                        {/* Hero Content */}
                        <div className="row justify-content-center mb-5">
                            <div className="col-lg-8 text-center">
                                <h1 style={{
                                    fontSize: 'clamp(2rem, 5vw, 3rem)',
                                    fontWeight: 700,
                                    marginBottom: '2rem',
                                    letterSpacing: '-0.02em',
                                    lineHeight: 1.2,
                                    color: '#EFEFE3',
                                    fontFamily: "'Montserrat', sans-serif"
                                }}>
                                    Solutions
                                </h1>
                                <p className="lead mb-5" style={{
                                    fontSize: '1.2rem',
                                    color: '#D5D6CC',
                                    lineHeight: '1.6'
                                }}>
                                    From Marine Protected Areas to offshore infrastructure, aquaculture operations to bioprospecting initiatives, our eDNA-powered solutions deliver the biodiversity intelligence you need to make confident decisions, ensure compliance, and demonstrate measurable impact. Each solution is tailored to your sector's unique challenges, backed by cutting-edge genomics and AI.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Solutions Cards */}
                    {solutions.map((solution, index) => (
                        <SolutionCard key={solution.id} solution={solution} index={index} />
                    ))}

                    {/* Call to Action */}
                    <div className="container">
                        <div className="text-center mt-5 pt-4">
                            <p className="mb-3" style={{ fontSize: '1.1rem', color: '#D5D6CC' }}>
                                Ready to transform your environmental monitoring?
                            </p>
                            <a href="/#contact" style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.75rem',
                                padding: '1rem 2.5rem',
                                background: 'linear-gradient(135deg, rgba(24, 195, 186, 0.15) 0%, rgba(24, 195, 186, 0.25) 100%)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(24, 195, 186, 0.3)',
                                borderRadius: '50px',
                                color: '#18C3BA',
                                textDecoration: 'none',
                                fontSize: '1.1rem',
                                fontWeight: 600,
                                fontFamily: "'Montserrat', sans-serif",
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                boxShadow: '0 8px 25px rgba(24, 195, 186, 0.15)',
                                position: 'relative',
                                overflow: 'hidden'
                            }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.background = 'linear-gradient(135deg, rgba(24, 195, 186, 0.25) 0%, rgba(24, 195, 186, 0.35) 100%)';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 12px 35px rgba(24, 195, 186, 0.25)';
                                    e.currentTarget.style.borderColor = 'rgba(24, 195, 186, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.background = 'linear-gradient(135deg, rgba(24, 195, 186, 0.15) 0%, rgba(24, 195, 186, 0.25) 100%)';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(24, 195, 186, 0.15)';
                                    e.currentTarget.style.borderColor = 'rgba(24, 195, 186, 0.3)';
                                }}
                            >
                                <span>Get in Touch</span>
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    style={{
                                        transition: 'transform 0.3s ease'
                                    }}
                                >
                                    <path
                                        d="M7 17L17 7M17 7H7M17 7V17"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </a>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default SolutionsPage;
